import { PageHeader, Reveal, useSeo } from "@/components/site/Motion";

export default function AboutSystem() {
  useSeo("About this Publishing System");
  return (
    <div data-testid="about-system-page">
      <PageHeader eyebrow="Platform" title="About this Publishing System" />
      <Reveal className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-28">
        <p className="font-display text-3xl leading-snug max-w-3xl">
          This journal uses Open Journal Systems, which is open source journal management and publishing software developed, supported, and freely distributed by the{" "}
          <a href="https://pkp.sfu.ca/" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 text-[var(--emerald)]" data-testid="pkp-link">Public Knowledge Project</a> under the GNU General Public License.
        </p>
      </Reveal>
    </div>
  );
}
